import cx from 'classnames';
import type React from 'react';

type OwnProps = {
  hideIcon?: boolean;
  isMobile?: boolean;
  svgIcon: React.ReactNode;
  useMobileIcon?: boolean;
};

export default function CTIcon({
  hideIcon = false,
  svgIcon,
  useMobileIcon = true
}: OwnProps) {
  return (
    <div
      className={cx(
        'flex-col justify-center self-center',
        useMobileIcon ? 'mr-20 h-32 w-32 m:m-0 m:h-56 m:w-56' : 'h-56 w-56',
        hideIcon ? 'hidden' : 'flex'
      )}
    >
      {svgIcon}
    </div>
  );
}
